module.exports = __webpack_public_path__ + "static/media/Ram Kumar.91de0a5c.png";